import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";
import Select from "react-select";

const equipmentTypeOptions = [
    { label: "Induction Motor", value: "InductionMotor" },
    { label: "Capacitor Bank", value: "Capacitor Bank" },
    { label: "Utility Main", value: "UtilityMain" },
    // { label: "DC Motor", value: "DCMotor" },
    { label: "Generator", value: "Generator" },
];

const voltageTapLocationOptions = [
    { label: "Load Side", value: "Load side" },
    { label: "Line Side", value: "Line side" },
    // { label: "Other", value: "" },
];

const CTLocationOptions = [
    { label: "Load Side", value: "Motor Load" },
    { label: "Line Side", value: "Line Side" },
    // { label: "Motor Load + Auxiliary", value: "Motor Load + Auxiliary" },
    // { label: "Other", value: "" },
];

const starterOptions = [
    { label: "FVNR", value: "FVNR" },
    // { label: "FVNR + DC Brake", value: "FVNR + DC Brake" },
    // { label: "DC Armature", value: "DC Armature" },
    { label: "Soft Starter", value: "Soft Starter" },
    { label: "VFD", value: "VFD" },
    // { label: "Soft Start + DC Brake", value: "Soft Start + DC Brake" },
    // { label: "Synchronous", value: "Synchronous" },
    // { label: "Other", value: "" },
];

const invalidEQNameChars = /[^a-z0-9\s\#]/i;
const validFloat = /^\d*\.?\d*$/;
const maxNameLength = 25;
const maxIntDefault = 100000;
const maxIntSmall = 360;
const maxSf = 20;

export default function EquipmentTable({ props, setProps, disabled }) {
    const [isValid, setIsValid] = useState({
        name: true,
        voltage: true,
        current: true,
        sf: true,
        freq: true,
        rpm: true,
        hp: true,
        poles: true,
        rotorBars: true,
        eqType: true,
    });

    const updateTable = (key, value) => {
        const tempProps = { ...props };
        tempProps[key] = value;
        setProps(tempProps);
    };

    const updateValid = (key, value) => {
        const tempValidState = { ...isValid };
        tempValidState[key] = value;
        setIsValid(tempValidState);
    };

    const onEquipmentNameUpdate = (val) => {
        var valid = true;
        if (invalidEQNameChars.test(val) || val.length > maxNameLength) {
            valid = false;
        }
        updateValid("name", valid);
        updateTable("equipmentName", val);
    };

    const onNumberInputUpdate = (key, val, max = maxIntDefault) => {
        if (val.length == 0) {
            updateTable(key, "");
            return;
        }
        if (!validFloat.test(val)) {
            return;
        }
        const float = parseFloat(val);

        var valid = true;
        if (Number.isNaN(float)) valid = false;
        if (float > max) valid = false;
        if (float <= 0) valid = false;

        updateValid(key, valid);
        updateTable(key, val);
    };

    // Update the dropdowns based on value given by props
    useEffect(() => {
        const tempProps = { ...props };
        var update = false;
        if (props._starter != null) {
            tempProps["starter"] = starterOptions.find((v) => v.value == props._starter);
            tempProps["_starter"] = null;
            update = true;
        }
        if (props._CTLocation != null) {
            tempProps["CTLocation"] = CTLocationOptions.find((v) => v.value == props._CTLocation);
            tempProps["_CTLocation"] = null;
            update = true;
        }
        if (props._vTapLocation != null) {
            tempProps["vTapLocation"] = voltageTapLocationOptions.find((v) => v.value == props._vTapLocation);
            tempProps["_vTapLocation"] = null;
            update = true;
        }
        if (props._equipmentType != null) {
            tempProps["equipmentType"] = equipmentTypeOptions.find((v) => v.value == props._equipmentType);
            tempProps["_equipmentType"] = null;
            update = true;
        }
        if (update) {
            setProps(tempProps);
        }
    }, [props]);

    return (
        <Col className="EquipmentTable">
            <label>Equipment Name </label>
            <br></br>
            <Form.Group>
                <Form.Control
                    type="string"
                    value={props.equipmentName}
                    onChange={(val) => onEquipmentNameUpdate(val.target.value)}
                    disabled={disabled}
                    isInvalid={!isValid.name}
                />
                <Form.Control.Feedback type="invalid">
                    Equipment Name must be no more than 25 characters and only include letters, numbers, spaces, and "#"
                </Form.Control.Feedback>
            </Form.Group>

            <br />
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th>Required Information</th>
                        <th>Values</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Equipment Type</td>
                        <td>
                            <Select
                                defaultValue={props.equipmentType}
                                value={props.equipmentType}
                                onChange={(value) => updateTable("equipmentType", value)}
                                options={equipmentTypeOptions}
                                isDisabled={disabled}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Starter</td>
                        <td>
                            <Select
                                defaultValue={props.starter}
                                value={props.starter}
                                onChange={(value) => updateTable("starter", value)}
                                options={starterOptions}
                                isDisabled={disabled}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Voltage Tap Location</td>
                        <td>
                            <Select
                                defaultValue={props.vTapLocation}
                                value={props.vTapLocation}
                                onChange={(value) => updateTable("vTapLocation", value)}
                                options={voltageTapLocationOptions}
                                isDisabled={disabled}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>CT Location</td>
                        <td>
                            <Select
                                defaultValue={props.CTLocation}
                                value={props.CTLocation}
                                onChange={(value) => updateTable("CTLocation", value)}
                                options={CTLocationOptions}
                                isDisabled={disabled}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Voltage Rating (V)</td>
                        <td>
                            <Form.Group>
                                <Form.Control
                                    value={props.voltage}
                                    onChange={(e) => onNumberInputUpdate("voltage", e.target.value)}
                                    type="text"
                                    disabled={disabled}
                                    isInvalid={!isValid.voltage}
                                    required={true}
                                />
                                <Form.Control.Feedback type="invalid">
                                    Must be a number between 1 and {maxIntDefault}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </td>
                    </tr>
                    <tr>
                        <td>Current Full Load Amps (A)</td>
                        <td>
                            <Form.Group>
                                <Form.Control
                                    value={props.current}
                                    onChange={(e) => onNumberInputUpdate("current", e.target.value)}
                                    type="text"
                                    isInvalid={!isValid.current}
                                    disabled={disabled}
                                    required={true}
                                />
                                <Form.Control.Feedback type="invalid">
                                    Must be a number between 1 and {maxIntDefault}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </td>
                    </tr>
                    <tr>
                        <th className="divider">Optional</th> <th className="divider" />
                    </tr>
                    <tr>
                        <td>Service Factor</td>
                        <td>
                            <Form.Group>
                                <Form.Control
                                    value={props.sf}
                                    onChange={(e) => onNumberInputUpdate("sf", e.target.value, maxSf)}
                                    type="text"
                                    isInvalid={!isValid.sf}
                                    disabled={disabled}
                                />
                                <Form.Control.Feedback type="invalid">
                                    Must be a number between 0 and {maxSf}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </td>
                    </tr>
                    <tr>
                        <td>Frequency (Hz)</td>
                        <td>
                            <Form.Group>
                                <Form.Control
                                    value={props.freq}
                                    onChange={(e) => onNumberInputUpdate("freq", e.target.value)}
                                    type="text"
                                    isInvalid={!isValid.freq}
                                    disabled={disabled}
                                />
                                <Form.Control.Feedback type="invalid">
                                    Must be a number between 1 and {maxIntDefault}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </td>
                    </tr>
                    <tr>
                        <td>RPM</td>
                        <td>
                            <Form.Group>
                                <Form.Control
                                    value={props.rpm}
                                    onChange={(e) => onNumberInputUpdate("rpm", e.target.value)}
                                    type="text"
                                    isInvalid={!isValid.rpm}
                                    disabled={disabled}
                                />
                                <Form.Control.Feedback type="invalid">
                                    Must be a number between 1 and {maxIntDefault}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </td>
                    </tr>
                    <tr>
                        <td>HP</td>
                        <td>
                            <Form.Group>
                                <Form.Control
                                    value={props.hp}
                                    onChange={(e) => onNumberInputUpdate("hp", e.target.value)}
                                    type="text"
                                    isInvalid={!isValid.hp}
                                    disabled={disabled}
                                />
                                <Form.Control.Feedback type="invalid">
                                    Must be a number between 1 and {maxIntDefault}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </td>
                    </tr>
                    <tr>
                        <td>Poles</td>
                        <td>
                            <Form.Group>
                                <Form.Control
                                    value={props.poles}
                                    onChange={(e) => onNumberInputUpdate("poles", e.target.value, maxIntSmall)}
                                    type="text"
                                    isInvalid={!isValid.poles}
                                    disabled={disabled}
                                />
                                <Form.Control.Feedback type="invalid">
                                    Must be a number between 1 and {maxIntSmall}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </td>
                    </tr>
                    <tr>
                        <td>Rotor Bars</td>
                        <td>
                            <Form.Group>
                                <Form.Control
                                    value={props.rotorBars}
                                    onChange={(e) => onNumberInputUpdate("rotorBars", e.target.value, maxIntSmall)}
                                    type="text"
                                    isInvalid={!isValid.rotorBars}
                                    disabled={disabled}
                                />
                                <Form.Control.Feedback type="invalid">
                                    Must be a number between 1 and {maxIntSmall}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </td>
                    </tr>
                </tbody>
            </table>
            {/* <Button onClick={onSubmit}>Create Location</Button> */}
        </Col>
    );
}
